import React from 'react';
import { FormControlLabel, FormLabel, Radio, RadioGroup } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Control, Controller, FieldValues } from 'react-hook-form';
import { CheckBox as CheckBoxIcon, CheckBoxOutlineBlank } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import { SortingCenter } from 'types';
import { transformObjectId } from 'services/apiPlatformTransformer';

const useStyles = makeStyles(theme => ({
  titleHeader2: {
    width: '100%',
    marginTop: '12px',
    marginBottom: '8px',

    '& span': {
      fontSize: '14px',
      fontWeight: '600',
      lineHeight: '20px',
    },
  },
  titleSpace: {
    height: '10px',
    marginRight: '15px',
    display: 'inline-block',
    width: '60px',
    borderBottom: '1px solid #CFD4DA',
  },
  fullWidth: {
    width: '100%',
  },
  divFlex: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  divFlexChild1: {
    width: '20%',
    paddingTop: '9px',

    '& label': {
      marginLeft: '75px',
      verticalAlign: 'middle',
      fontSize: '14px',
      fontWeight: 600,
      lineHeight: '16px',
      color: '#000000',
    },
  },
  divFlexChild2: {
    width: '26.6%',

    '& label span': {
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '16px',
    },

    '& label span.Mui-disabled:last-child': {
      color: '#000000 !important',
    },
  },
  primary: {
    color: theme.palette.primary.main,
  },
}));

interface ElementListUserRolesProps {
  sortingCenter: SortingCenter;
  totalSortingCenter: number;
  sortingCenterUserRoleInitial: string[];
  control: Control<FieldValues, object>;
}

const ListUserRoles: React.FC<ElementListUserRolesProps> = ({
  sortingCenter,
  totalSortingCenter,
  sortingCenterUserRoleInitial,
  control,
}) => {
  const classes = useStyles();
  const { t } = useTranslation('translation', { keyPrefix: 'administration.users.create' });

  const hasMultipleChild = Boolean(totalSortingCenter > 1);
  const sortingCenterId = parseInt(transformObjectId(sortingCenter), 10);

  return (
    <>
      {hasMultipleChild && (
        <div className={classes.titleHeader2}>
          <div className={classes.titleSpace}>&nbsp;</div>
          <span>
            {sortingCenter.name} - <span className={classes.primary}>{sortingCenter.code}</span>
          </span>
        </div>
      )}
      <div className={classes.divFlex}>
        <Controller
          name={`sortingCenterUserRole.${sortingCenterId}`}
          control={control}
          render={({ field }) => (
            <RadioGroup row className={classes.fullWidth} {...field}>
              <div className={classes.divFlexChild1}>
                <FormLabel>
                  <span>{t('role')}</span>
                </FormLabel>
              </div>
              <div className={classes.divFlexChild2}>
                <FormControlLabel
                  label={t('userRoles.ROLE_MANAGER')}
                  value="ROLE_MANAGER"
                  labelPlacement="start"
                  control={
                    <Radio
                      color={'primary'}
                      checked={sortingCenterUserRoleInitial[sortingCenterId] === 'ROLE_MANAGER' || undefined}
                      disabled={Boolean(sortingCenterUserRoleInitial[sortingCenterId])}
                      checkedIcon={<CheckBoxIcon />}
                      icon={<CheckBoxOutlineBlank />}
                    />
                  }
                />
              </div>
              <div className={classes.divFlexChild2}>
                <FormControlLabel
                  label={t('userRoles.ROLE_ASSISTANT')}
                  value="ROLE_ASSISTANT"
                  labelPlacement="start"
                  control={
                    <Radio
                      color={'primary'}
                      checked={sortingCenterUserRoleInitial[sortingCenterId] === 'ROLE_ASSISTANT' || undefined}
                      disabled={Boolean(sortingCenterUserRoleInitial[sortingCenterId])}
                      checkedIcon={<CheckBoxIcon />}
                      icon={<CheckBoxOutlineBlank />}
                    />
                  }
                />
              </div>
              <div className={classes.divFlexChild2}>
                <FormControlLabel
                  label={t('userRoles.ROLE_CONSULTATION')}
                  value="ROLE_CONSULTATION"
                  labelPlacement="start"
                  control={
                    <Radio
                      color={'primary'}
                      checked={sortingCenterUserRoleInitial[sortingCenterId] === 'ROLE_CONSULTATION' || undefined}
                      disabled={Boolean(sortingCenterUserRoleInitial[sortingCenterId])}
                      checkedIcon={<CheckBoxIcon />}
                      icon={<CheckBoxOutlineBlank />}
                    />
                  }
                />
              </div>
            </RadioGroup>
          )}
        />
      </div>
    </>
  );
};

export default ListUserRoles;
